const prefix = process.env.NODE_ENV === 'development' ? 'verification' : 'verification';

export const verify_token = `${prefix}/verify`;
